module.exports = __webpack_public_path__ + "img/home.b140f3b3.jpg";